import {logger} from '../../../utils/logging/logger'
import {warnServerEnvironment} from '../logging/server-warning'

/**
 *
 *Set item on local storage or session storage in a safe way, logging an error when the window objects does not exists
 * @example set `searchUri` on local storage
 *
 * ```
 * safelySetStorageItem(localStorage, 'searchUri', 'https://www.findhotel.net/', 'setSearchUri failed')
 * ```
 * @param storageOption - the storage where to set the item. Local storage or Session storage
 * @param param - the chosen parameter to set on the storage
 * @param value - the value to set on the storage
 * @param errorString - the error message to log when it fails
 */
export const safelySetStorageItem = (
  storageOption:
    | typeof localStorage
    | typeof sessionStorage
    | 'localStorage'
    | 'sessionStorage',
  param: string,
  value: string,
  errorString?: string
): void => {
  if (typeof window === 'undefined') {
    warnServerEnvironment(`set ${storageOption}.${param}`)
    return undefined
  }
  try {
    const storage =
      typeof storageOption === 'string' ? window[storageOption] : storageOption
    storage.setItem(param, value)
  } catch (err) {
    logger.error('safelySetStorageItem:', {errorString, err})
  }
}
